// extracted by mini-css-extract-plugin
module.exports = {"Auth":"Auth_Auth__1Zul_","authInput":"Auth_authInput__Sthep"};